import React from "react";

const sectionHeader = ({header}) => {
  return(
      <div className="row">
          <div className="col-md-12">
              <div className="sec-title capitalized">
                  <h2 className="text-center loon header-padding capitalized">{ header }</h2>
              </div>
          </div>
      </div>
  )
};

export default sectionHeader;